// React Polyfill to ensure proper hook availability
// This fixes issues with use-sync-external-store-shim and similar libraries

import * as React from 'react';

// Ensure React is globally available for compatibility
declare global {
  interface Window {
    React: typeof React;
    ReactHooks: any;
    __REACT_DEVTOOLS_GLOBAL_HOOK__?: any;
  }
}

// Make React globally available
if (typeof window !== 'undefined') {
  window.React = React;
  
  // Create a separate ReactHooks object instead of modifying React directly
  window.ReactHooks = {
    useState: React.useState,
    useEffect: React.useEffect,
    useContext: React.useContext,
    useReducer: React.useReducer,
    useCallback: React.useCallback,
    useMemo: React.useMemo,
    useRef: React.useRef,
    useImperativeHandle: React.useImperativeHandle,
    useLayoutEffect: React.useLayoutEffect,
    useDebugValue: React.useDebugValue,
    useDeferredValue: (React as any).useDeferredValue,
    useTransition: (React as any).useTransition,
    useId: (React as any).useId,
    useSyncExternalStore: (React as any).useSyncExternalStore,
    useInsertionEffect: (React as any).useInsertionEffect,
  };

  // Ensure React internals are available - just check, don't modify
  if (!(window.React as any).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) {
    console.warn('React internals not found - potential compatibility issues');
  }
  
  console.log('✅ React polyfill loaded successfully');
}

export default React;
